<template>
  <div class="responsive-table">
    <table ref="table" class="responsive-table__table" :class="{'responsive-table__table_mobile' : isMobile}">
      <thead ref="thead">
      <tr class="responsive-table__tr">
        <slot name="thead" />
      </tr>
      </thead>

      <slot v-if="noTbody" :data="datax" />
      <tbody v-else>
      <slot :data="datax" />
      </tbody>
    </table>
  </div>

</template>

<script>
export default {
  name:     "RtTable",
  props:    {
    data:                 {},
    breakpoint:           {
      default: 0,
    },
    mobileActive:         {
      default: false,
      type:    Boolean,
    },
    noMobileBorderBottom: {
      default: false,
      type:    Boolean,
    },
    noTbody:              {
      default: false,
      type:    Boolean,
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth <= this.breakpoint || this.mobileActive;
    },
    datax() {
      return this.data;
    },
    windowWidth() {
      return this.$store.getters["windowWidth"] || this.$store.state.app.windowWidth;
    },
  },
};
</script>

<style lang="scss">
.responsive-table {
  overflow: auto;
  max-width: 100%;

  &__table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 2px;

    &_mobile {
      .responsive-table {

        &__th {
          display: none;
        }

        &__td {
          border-bottom: none;
          margin: .5rem 0;
          display: block;

          &_mobile-hidden {
            display: none;
          }

          .responsive-td__content {
            display: flex;
            align-items: center;
            padding: 0;

            &-text {
              text-align: right;
              flex: 1;
              padding-right: 5px;
            }
          }

          &:last-child {
            border-bottom: 1px solid #dee2e6;

            .responsive-td__content {
              padding-bottom: .75rem;
            }
          }
        }

        &__tr.noMobileBorderBottom {
          .responsive-table__td:last-child {
            border-bottom: none;
          }
        }

        &__mobile-header {
          display: block;
          padding-left: 5px;
        }
      }
    }

  }

  &__th {
    /*border-bottom: 1px solid #dee2e6;*/
    /*background-color: #f4f4f4;*/
  }

  &__td {
    /*border-bottom: 1px solid #dee2e6;*/
  }

  &__mobile-header {
    display: none;
    font-weight: 500;
    padding-right: 10px;
  }
}
</style>
